export default class TagService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/tags', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/tags', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('me/tags/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/tags/' + id, params)
	}

	// BY OPERATOR ID
	searchTagByNameAndOperatorId(operatorId, params){
		return this.apiService.callGet(''+ operatorId+'/tags_search', params);
	}
}



// WEBPACK FOOTER //
// ./src/service/TagService.js